import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import { makeMainRoutes } from './routes/routes';
import { superAdminRoutes } from './routes/routesSuperAdmin';
const routes = makeMainRoutes();
const routesSuperAdmin = superAdminRoutes();

let str = routesSuperAdmin.props.children.props.history.location.pathname;

if(str.indexOf('/admin') > -1){
	ReactDOM.render(
	  routesSuperAdmin,
	  document.getElementById('root')
	);
}else{
	ReactDOM.render(
  		routes,
  		document.getElementById('root')
	);
}



// WEBPACK FOOTER //
// ./src/index.js